var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThumbsUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6207 2.74192C14.9346 2.25036 14.0866 2.44702 13.5794 2.91411L7.78576 8.25H4.33398C3.36749 8.25 2.58398 9.0335 2.58398 10V20C2.58398 20.9665 3.36749 21.75 4.33398 21.75H8.08398L18.0305 21.75C19.407 21.75 20.5714 20.7323 20.7557 19.3682L21.7709 11.8541C21.9938 10.204 20.7107 8.73596 19.0456 8.73596H16.0193C16.687 7.6413 17.0471 6.6408 17.0935 5.73189C17.1596 4.437 16.584 3.43214 15.6207 2.74192ZM6.58398 20.25V9.75H4.33398C4.19591 9.75 4.08398 9.86193 4.08398 10V20C4.08398 20.1381 4.19591 20.25 4.33398 20.25H6.58398ZM8.08398 20.25H18.0305C18.6561 20.25 19.1854 19.7874 19.2692 19.1673L20.2844 11.6533C20.3857 10.9033 19.8025 10.236 19.0456 10.236H14.5932C14.3081 10.236 14.0476 10.0743 13.9211 9.8187C13.7946 9.56315 13.8239 9.25797 13.9968 9.03121C15.1206 7.55741 15.5549 6.44892 15.5954 5.65545C15.6327 4.92445 15.341 4.38683 14.7471 3.96125C14.7454 3.95994 14.7387 3.95455 14.7144 3.95751C14.6835 3.96127 14.6378 3.97854 14.5956 4.01746L8.08398 10.0146V20.25Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsUp);
export default __webpack_public_path__ + "static/media/ThumbsUp.4b3dfbbc65f2dd611abf431806a75683.svg";
export { ForwardRef as ReactComponent };